namespace gotoAndPlay {

    $(function() {
        $(document).on('click', '.broadcast__suggestion-item', function(event) {
            event.preventDefault();

            let id     = $(this).data('id');
            let parent = $(this).parents('.broadcast');
            $('.broadcast__video', parent).addClass('h-hidden');
            $('.broadcast__suggestion-item.is-playing', parent).removeClass('is-playing');
            ($('.video[data-id="' + id + '"]', parent).removeClass('h-hidden').data('video') as Video).loadPlayer(null, id);
            $(this).addClass('is-playing');
        });

        $('.js-broadcast__suggestions-inner').scroll((event) => {
            let scrollarea = event.currentTarget;
            if ($(scrollarea).scrollTop() + $(scrollarea).height() == scrollarea.scrollHeight) {
                Video.loadMoreVideos(true);
            }
        });
    });

}
